<template>
    <div class="mt-3">
        <div class="row">
            <div class="col-sm-4 modspec_font14">Glazing</div>
        </div>
        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <!------------------------------->
                <div class="row">
                    <div class="col-sm-4 modspec_font14">
                        External Glazing:
                    </div>
                    <div class="col-sm-2 modspec_font10">U-value</div>
                    <div class="col-sm-2"><input type="text" class="form-control" placeholder="i.e. 6.4" /></div>
                    <div class="col-sm-2 modspec_font10">SHGC</div>
                    <div class="col-sm-2"><input type="text" class="form-control" placeholder="i.e. 0.45" /></div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-4 modspec_font14">
                        Other Glazing:
                    </div>
                    <div class="col-sm-2 modspec_font10">U-value</div>
                    <div class="col-sm-2"><input type="text" class="form-control" placeholder="i.e. 6.4" /></div>
                    <div class="col-sm-2 modspec_font10">SHGC</div>
                    <div class="col-sm-2"><input type="text" class="form-control" placeholder="i.e. 0.45" /></div>
                </div>
                <div class="row mt-2">
                    <div class="col-sm-8">
                        <textarea cols="20" style="width:100%"
                            placeholder="Add any additional notes to describe the external glazing specification"></textarea>
                    </div>
                </div>
                <!------------------------------->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "cd-glazing",
    data: function () {
        return {
            glazing: {  },
            //number:0
        }
    },
    mounted() {

    },
    methods: {
        test(){
            this.glazing = {  };
        },

    },
}
</script>
<style></style>